export default __webpack_public_path__ + "static/media/bbps-CreditCard.2affe596.svg";